<template>
  <div class="product-card mouse" @click="$emit('toBuy')">
    <!-- 产品图片区域 -->
    <div class="product-image">
      <el-image v-if="product.mainImage" class="image" :src="product.mainImage" />
      <img v-else src="../../../../../assets/images/default.png" class="image" />
      <!-- 倒计时 -->
      <div class="countdown" v-if="validEndTime" :key="validEndTime">
        {{ validEndTime }}
      </div>
      <div class="copy-icon" @click.stop="$emit('copy')">
        <img src="../../../../../assets/images/copy.png" />
      </div>
    </div>
    <div>
      <!-- 产品信息区域 -->
      <div class="product-info">
        <!-- 直播间信息 -->
        <div class="live-info">
          <img src="../../../../../assets/images/dy.png" class="live-icon" />
          <span class="live-room">{{ product.liveRoomName }}</span>
            {{ product.categoryName }} {{ product.brandName }} {{ product.productName }} {{ product.activityMechanism || '' }}
        </div>
        
        <!-- 失效时间 -->
        <div class="expiry-time">
          <span v-if="sortType === 3">
            失效时间：{{ computedTime(product.validEndTime) }}
          </span>
        </div>
      </div>
      
      <!-- 价格信息区域 -->
      <div class="price-info">
        <div class="discount-info">
          爆品限时补贴至
        </div>
        <div class="price" v-if="product.userRebateStr !== '' || product.userRebatePrice !== null">
          {{ product.userRebateStr }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ProductCard',
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    sortType: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      validEndTime: ''
    }
  },
  created () {
    this.initValidTime()
  },
  methods: {
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    initValidTime () {
      if (!this.product.validEndTime) {
        return
      }
      this.interval = setInterval(() => {
        this.validEndTime = this.computedValidTime(this.product.validEndTime)
      }, 1000)
    },
    computedValidTime (date) {
      if (!date) {
        return ''
      }

      // 如果已过期，返回“已结束”
      if (moment().isAfter(moment(date))) {
        return '已结束'
      }

      const diff = moment.duration(moment(date).diff(moment()))
      const days = Math.floor(diff.asDays())
      const hours = diff.hours()
      const minutes = diff.minutes()
      const seconds = diff.seconds()
      if (days > 0) {
        return `仅剩${days}天${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      } else if (hours > 0) {
        return `仅剩${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      } else if (minutes > 0) {
        return `仅剩${minutes}:${String(seconds).padStart(2, '0')}`
      } else {
        return `仅剩${seconds}秒`
      }
    }
  }
}
</script>

<style scoped>
.product-card {
  width: 100%;
  padding-top: 100%;
  border-radius: 2px;
  overflow: hidden;
  background-color: #fff;
  position: relative;
}

.product-image {
  width: 100%;
  overflow: hidden;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}

.product-image img {
  border-radius: 2px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.countdown {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(10, 10, 10, 0.6);
  color: #fff;
  padding: 4px 8px;
  border-radius: 2px;
  font-size: 12px;
}

.product-info {
  padding: 12px;
}

.live-info { 
  margin-bottom: 8px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 700;
  height: 32px;
  overflow: hidden;
}

.live-icon {
  margin-top: 2px;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  vertical-align: middle;
  float: left;
}

.live-room {
  border: solid 1px #ff4d4f;
  color: rgba(255, 53, 176, 1);
  line-height: 14px;
  border-radius: 2px;
  font-size: 12px;
  height: 14px;
  overflow: hidden;
  font-weight: bold;
  float: left;
  margin-right: 4px;
  max-width: calc(100% - 22px);
}

.product-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 1.4;
}

.expiry-time {
  font-size: 12px;
  color: #999;
}

.price-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  line-height: 36px;
  background-color: rgba(255, 240, 249, 1);
}

.discount-info {
  padding: 0 12px;
  font-size: 14px;
  color: rgba(255, 85, 204, 1);
  font-weight: 500;
}

.price {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  padding: 0 18px;
  background-color: rgba(255, 77, 170, 1);
}
.copy-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
}
.copy-icon img {
  cursor: pointer;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>